import universeFields from "./universeFields";
export default {
    dataSource: {
        assetAllocationDataSource: "aws",
        parentApplication: "AWS",
        customBenchmark: true
    },
    resourceLimit: {
        savedFiles: 1000,
        securityNumber: 80,
        reportArchiveDays: 1095,
        portfolioNumber: 2
    },
    colors: {
        netColor: "#333333",
        benchmarkColor: "#6A4C9E;#E60546;#C19C31",
        portfolioColor: "#00A8E1;#005F5F;#7D256F"
    },
    localization: {
        countryCode: "US",
        showCountry: true,
        stateOrProvince: "state"
    },
    showMFComprehensive: false,
    assumptionWorkflow: 0,
    applyStartDateType: 0, //When Trailing N Year is not available, 0: Earliest Available, 1: Earliest Common
    isScenarioAnalysisEnabled: true,
    languageList: [
        { label: "English (US)", value: "en-US" },
        { label: "English (CAN)", value: "en-CA" },
        { label: "中文简体", value: "zh-CN" },
        { label: "Français (CAN)", value: "fr-CA" }
    ],
    currencyList: [
        {
            currencyId: "USD",
            currencyName: "US Dollar (United States)",
            currencySymbol: "$",
            countryId: "USA"
        },
        {
            currencyId: "GBP",
            currencyName: "Pound Sterling (United Kingdom)",
            currencySymbol: "£",
            countryId: "GBR"
        },
        {
            currencyId: "CNY",
            currencyName: "Yuan Renminbi (China)",
            currencySymbol: "¥",
            countryId: "CHN"
        },
        {
            currencyId: "CAD",
            currencyName: "Canadian Dollar (Canada)",
            currencySymbol: "$",
            countryId: "CAN"
        },
        {
            currencyId: "EUR",
            currencyName: "EURO (All European)",
            currencySymbol: "€",
            countryId: "EUR"
        },
        {
            currencyId: "AUD",
            currencyName: "Australian Dollar (Australia)",
            currencySymbol: "$",
            countryId: "AUS"
        }
    ],
    universeList: [
        {
            Type: "USAFO",
            Name: "U.S. Mutual Funds"
        },
        {
            Type: "USAST",
            Name: "U.S. Stock"
        },
        {
            Type: "USABOND",
            Name: "U.S. Bonds"
        },
        {
            Type: "USAFE",
            Name: "U.S. ETF"
        },
        {
            Type: "USAFC",
            Name: "Closed End Funds"
        }
    ],
    universeFields: universeFields,
    optionList: [
        { text: "Universe", value: "UNIVERSE" },
        { text: "Cash", value: "USACASH" }
    ],
    portfolioSettingModules: [
        { value: "HOLDINGS", labelKey: "COMPONENT_HOLDINGS" },
        { value: "REINVESTMENTS", labelKey: "COMPONENT_REINVESTMENTS" },
        { value: "CONTRIWITHDRAW", labelKey: "COMPONENT_CONTRIBUTIONS_WITHDRAWALS" },
        { value: "REBALANCING", labelKey: "COMPONENT_REBALANCING" },
        { value: "FEES", labelKey: "COMPONENT_FEES" },
        { value: "TAXES", labelKey: "COMPONENT_TAXES" },
        { value: "BENCHMARK", labelKey: "COMPONENT_BENCHMARK" }
    ],
    reportOptions: [
        { reportId: "CoverPage", labelKey: "REPORT_COVER_PAGE", disabled: true, visible: true },
        { reportId: "MarketingPage", labelKey: "REPORT_MARKETING_PAGE", disabled: false, visible: true },
        { reportId: "DistributionWithdrawalComparison", labelKey: "REPORT_DISTRIBUTION_WITHDRAWAL_COMPARISON", disabled: false, visible: true },
        { reportId: "PortfolioComparison", labelKey: "REPORT_PORTFOLIO_COMPARISON", disabled: false, visible: true },
        { reportId: "DistributionWithdrawal", labelKey: "REPORT_DISTRIBUTION_WITHDRAWAL_SUMMARY", disabled: false, visible: true },
        { reportId: "XRay", labelKey: "REPORT_Portfolio_XRay", disabled: false, visible: true },
        { reportId: "Snapshot", labelKey: "REPORT_SNAPSHOT", disabled: false, visible: true },
        { reportId: "StockIntersection", labelKey: "REPORT_STOCK_INTERSECTION", disabled: false, visible: true },
        { reportId: "CAPortfolioSummary", labelKey: "REPORT_CA_PORTFOLIO_SUMMARY", disabled: false, visible: true },
        { reportId: "CAPortfolioServiceFees", labelKey: "REPORT_CA_PORTFOLIO_SERVICE_FEES", disabled: false, visible: true },
        { reportId: "RiskReward", labelKey: "REPORT_RISK_REWARD", disabled: false, visible: true },
        { reportId: "CorrelationMatrix", labelKey: "REPORT_CORRELATION_MATRIX", disabled: false, visible: true },
        { reportId: "TotalAnnualReturn", labelKey: "REPORT_TOTAL_ANNUAL_RETURN", disabled: false, visible: true },
        { reportId: "InvestmentGrowth", labelKey: "REPORT_INVESTMENT_GROWTH", disabled: false, visible: true },
        { reportId: "PortfolioRollingReturn", labelKey: "REPORT_PORTFOLIO_ROLLING_RETURNS", disabled: false, visible: true },
        { reportId: "RollingReturn", labelKey: "REPORT_ROLLING_RETURNS", disabled: false, visible: true },
        { reportId: "InvestmentDetail", labelKey: "REPORT_INVESTMENT_DETAIL", disabled: false, visible: true },
        { reportId: "UnderlyingHolding", labelKey: "REPORT_UNDERLYING_HOLDINGS", disabled: false, visible: true },
        { reportId: "PriceDistribution", labelKey: "REPORT_PRICE_DISTRIBUTION", disabled: false, visible: true },
        { reportId: "Cashflow", labelKey: "REPORT_CASH_FLOW", disabled: false, visible: true },
        { reportId: "CAFundSummary", labelKey: "REPORT_CA_FUND_SUMMARY", disabled: false, visible: true },
        { reportId: "CAStockSummary", labelKey: "REPORT_CA_STOCK_SUMMARY", disabled: false, visible: true },
        { reportId: "MORGInvestmentSummary", labelKey: "REPORT_MORGST_INVESTMENT_SUMMARY", disabled: false, visible: true },
        { reportId: "BLKManagementFees", labelKey: "REPORT_BLOCKROCK_MANAGEMENT_FEES", disabled: false, visible: true },
        { reportId: "Disclosure", labelKey: "REPORT_DISCLOSURE_MATERIALS", disabled: false, visible: true }
    ],
    hypoTypes: [
        {
            reportId: "PORTFOLIO",
            labelKey: "REPORT_PORTFOLIO_FOR_HYPO",
            visible: true,
            descriptionKey: "REPORT_PORTFOLIO_FOR_HYPO_DES"
        },
        {
            reportId: "PORTFOLIO_C",
            labelKey: "REPORT_PORTFOLIO_COMPARISON_FOR_HYPO",
            visible: true,
            descriptionKey: "REPORT_PORTFOLIO_COMPARISON_FOR_HYPO_DES"
        },
        {
            reportId: "INDVIL_H",
            labelKey: "REPORT_INDIVIDUAL_HOLDINGS_FOR_HYPO",
            visible: true,
            descriptionKey: "REPORT_INDIVIDUAL_HOLDINGS_FOR_HYPO_DES"
        }
    ]
};
